import { render, staticRenderFns } from "./Factor.vue?vue&type=template&id=3ba5461f&scoped=true"
import script from "./Factor.vue?vue&type=script&lang=js"
export * from "./Factor.vue?vue&type=script&lang=js"
import style0 from "./Factor.vue?vue&type=style&index=0&id=3ba5461f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba5461f",
  null
  
)

export default component.exports